import type { AssetsDataObject, FileAssetsDataObject, FolderAssetDataObject } from 'models/service';

/* eslint-disable @typescript-eslint/naming-convention -- Start: These variables represents type */
export const FileType = 'file';
export const FolderType = 'folder';
/* eslint-enable @typescript-eslint/naming-convention -- End: These variables represents type */

export type Asset = {
  id: string;
  name: string;
  parentId: null | string;
  updatedAt?: Date;
};

export type FileAsset = {
  contentType: string;
  downloadUrl: string;
  extension: string;
  size: number;
  type: typeof FileType;
} & Asset;

export type FolderAsset = {
  type: typeof FolderType;
} & Asset;

export const createAsset = (data: AssetsDataObject): Asset => ({
  id: data.id,
  name: data.name,
  parentId: data.parent_id,
  updatedAt: new Date(data.updated_at),
});

export const createFileAsset = (data: FileAssetsDataObject): FileAsset => ({
  ...createAsset(data),
  contentType: data.metadata.content_type,
  downloadUrl: data.metadata.download_url,
  extension: data.extension,
  size: data.metadata.byte_size,
  type: data.type,
});

export const createFolderAsset = (data: FolderAssetDataObject): FolderAsset => ({
  ...createAsset(data),
  type: data.type,
});
